// extracted by mini-css-extract-plugin
export default {"languageDropdown":"LanguageDropdown_languageDropdown__n9r1p"};